import { AdminAppState } from '../../state';
import { getSiteViewportState } from './get-site-viewport-state';

export const getSiteViewportWidth = (state: AdminAppState): number | string =>
  getSiteViewportState(state).width;
